// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv1epFJ3J@XIKFNZQ,47bSFVJ!k9_a[>Qay:JSn,J987+Rd2_4VZ>SJVYR:%JVE,%a%ViSEI_VZ%e!3:7y(3RViIn,g%%8BeLF7Zi+n!LR[9<ef,b+-Sn,J>_fyeY38!+d+cYRQe<4tV+XzZN-FVKmzZQt!cQR<cRXnpb+3I%Rv9eaBGJeaIncmkpR<6pRQ2RQ<6gf-SQ-Q6Jz<aj@@p1!vpK9;6<F@2_9B>%X<2p@@!Q462b-v2%d)I<-@aQd@pg@@!Q4@2_@F!Qd:Ip!@I<4)aKz<I_y66<!$I<-$aNRvI<4:>Q8vIbR)9jz;!jL;9jyFI7yFI7yFI9ll';
